import styled from 'styled-components'

export const OptionEmailStyled = styled.span`
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
  color: ${(props) => props.theme.colors.text.tertiary};
`
